import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";

const name = 'inspectorKPI';

const initialState = {
    criteria: {},
    data: [],
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setCriteria(state, action) {
            state.criteria = action.payload;
        },
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
    }
})

export const { setCriteria, setData} = slice.actions;
export const { reducer } = slice;

export const selectCriteria = state => state[name].criteria;
export const selectData = state => json.fromJSON(state[name].data);

const inspectorKPIReducer = reducer;
export default inspectorKPIReducer;